import React, { ReactNode } from 'react';
import Toolbar, { Item } from 'devextreme-react/toolbar';
import './ToolbarSimple.scss';

type ToolbarAnalyticsProps = {
  title?: string;
  subtitle?: string; // Added subtitle prop
  additionalToolbarContent?: ReactNode[];
};

export const ToolbarSimple = ({ title, subtitle, additionalToolbarContent, children }: React.PropsWithChildren<ToolbarAnalyticsProps>) => {
  return (
    <div className='view-wrapper view-wrapper-dashboard'>
      <Toolbar>
        {title && (
          <Item location='before'>
            <div className='toolbar-header-container'> {/* Added container for styling */}
              <span className='toolbar-header'>{title}</span>
              {subtitle && <p className='toolbar-subheader'>{subtitle}</p>} {/* Subtitle remains below */}
            </div>
          </Item>
        )}
        {additionalToolbarContent?.map((x) => x)}
      </Toolbar>
      {children}
    </div>
  );
};
